import type { AllHTMLAttributes, ReactNode } from "react";

import { useMemo } from "react";

import { CardButton } from "./card-button.component";
import { CardBody } from "./card-body.component";
import { CardHead } from "./card-head.component";

import styles from "./card.module.css";
import { classNames } from "../../support/formatters/class-formatter";

export type CardProps = {
  children: ReactNode;
  variant?: "vertical" | "horizontal";
} & AllHTMLAttributes<HTMLDivElement>;

export function Card({ children, variant = "vertical", className, ...props }: CardProps) {
  const cardClassName = useMemo(() => {
    if (variant === "horizontal") {
      return `${styles.Card} ${styles.Horizontal}`;
    }

    return styles.Card;
  }, [variant]);

  return (
    <div className={classNames(cardClassName, className)} {...props}>
      {children}
    </div>
  );
}

export namespace Card {
  export const Button = CardButton;
  export const Head = CardHead;
  export const Body = CardBody;
}
